export default __webpack_public_path__ + "b6e2abc3965df6f74554b0efa7afe5cf.png";